module.exports = __webpack_public_path__ + "static/media/nervous-1.35b38e2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/presentation/nervous-1.jpg
// module id = 432
// module chunks = 13